<template>
  <a-modal
    title="新建分类"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    ok-text="保存"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="mb-20">分类排序越大，则展示在越前面</div>
    <a-form-model
      ref="form"
      :model="formData"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :rules="rules"
    >
      <a-form-model-item
        label="分类名称"
        prop="name"
      >
        <a-input v-if="is_create" v-model="formData.name" :maxLength="10" placeholder="不能超过10个字" allowClear />
        <div v-else>{{ formData.name }}</div>
      </a-form-model-item>
      <a-form-model-item
        label="分类级别"
        required
        v-if="is_create"
      >
        <a-radio-group v-model="level">
          <a-radio :value="1">
            一级分类
          </a-radio>
          <a-radio :value="2">
            二级分类
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <template v-if="level===2">
        <a-form-model-item
          label="上级分类"
          prop="parent_id"
        >
          <a-select
            v-model="formData.parent_id"
            placeholder="选择上级分类"
            style="width: 220px"
          >
            <a-select-option v-for="(item, index) in categoryList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="分类图片"
          prop="picture"
        >
          <div>建议尺寸 60 * 60</div>
          <up-load v-model="formData.picture" />
        </a-form-model-item>
      </template>
      <template v-else>
        <!-- 选择品牌 -->
        <a-form-model-item
          label="所属品牌"
          prop="brand"
          v-if="is_create"
        >
          <a-select style="width: 300px" placeholder="选择品牌" v-model="formData.brand_id">
            <a-select-option v-for="(item, index) in brand_list" :key="index" :value="item.brand_id">{{ item.brand_name }}</a-select-option>
          </a-select>
        </a-form-model-item>
      </template>
      <a-form-model-item
        label="分类排序"
        prop="sort"
      >
        <a-input-number v-model="formData.sort" :min="0" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import UpLoad from '@/components/UpLoad'
import { getGoodsPre, postGoodsCategoryAdd, postGoodsCategoryEdit, getGoodsCategoryDetail } from '@/api/goods'
import { formatPath } from '@/utils'
import { getBrandList } from '@/api/brand'

const defaultFormData = {
  name: '',
  parent_id: '',
  picture: '',
  sort: 0,
  brand_id: 1
}

export default {
  components: { UpLoad },
  data() {
    return {
      id: 0,
      visible: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      level: 1,
      brand_list: [],
      is_create: true,
      formData: Object.assign({}, defaultFormData),
      rules: {
        name: [{ required: true, message: '名称必填', trigger: 'blur' }],
        parent_id: [{ required: true, message: '上级分类必填', trigger: 'change' }],
        picture: [{ required: true, message: '图片必填', trigger: 'change' }],
        sort: [{ required: true, message: '排序必填', trigger: 'change' }]
      },
      categoryList: [] // 一级分类
    }
  },
  methods: {
    showModal(id = 0) {
      this.visible = true
      this.id = id
      this.getPre()
      if (id) {
        this.is_create = false
        this.getDetail()
      } else {
        this.is_create = true
        this.level = 1
        this.formData = Object.assign({}, defaultFormData)
      }
    },
    handleOk(e) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.id) {
            // 编辑
            this.postEdit()
          } else {
            // 新增
            this.postAdd()
          }
        } else {
          this.$message.error('还有字段未填写，请检查！')
          return false
        }
      })
    },
    handleCancel() {
      this.$refs.form.resetFields()
      this.visible = false
    },
    // 转换成接口所需参数
    paramsFormat() {
      const picture = formatPath(this.formData.picture)
      return Object.assign({}, this.formData, { picture })
    },
    // 编辑
    postEdit() {
      this.confirmLoading = true
      postGoodsCategoryEdit(this.paramsFormat())
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.handleCancel()
            this.$emit('ok')
          }
        })
        .catch((e) => {
          this.$message.error('保存失败')
        })
        .finally(() => { this.confirmLoading = false })
    },
    // 新增
    postAdd() {
      this.confirmLoading = true
      postGoodsCategoryAdd(this.paramsFormat())
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.handleCancel()
            this.$emit('ok')
          }
        })
        .catch((e) => {
          this.$message.error('保存失败')
        })
        .finally(() => { this.confirmLoading = false })
    },
    // 商品分类详情
    getDetail() {
      getGoodsCategoryDetail({
        category_id: this.id
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            if (!(data.parent_id)) {
              this.level = 1
            } else {
              this.level = 2
            }
            this.formData = {
              category_id: data.category_id,
              name: data.name,
              parent_id: data.parent_id,
              picture: data.picture,
              sort: data.sort,
              brand_id: data.brand_id
            }
          }
        })
        .catch((e) => {
          this.$message.error('请求商品分类详情接口失败')
        })
    },
    // 预加载
    getPre() {
      getBrandList()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.brand_list = data
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
      getGoodsPre()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.categoryList = data.categoryList
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
    }
  }
}
</script>
